var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpaceActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component_38",
    "data-name": "Component 38",
    transform: "translate(-20 -12)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1",
    "data-name": "Raggruppa 1"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_2",
    "data-name": "Ellisse 2",
    cx: 12,
    cy: 12,
    r: 12,
    transform: "translate(20 12)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4",
    "data-name": "Tracciato 4",
    d: "M34.25,26.1c3.27-2.9,5.8-6.718,4.318-8.391a2.1,2.1,0,0,0-1.836-.7,3.6,3.6,0,0,0-1.817.85,6.394,6.394,0,0,0-8.921,7.928c-.759.857-1.464,2.621-.587,3.609a1.953,1.953,0,0,0,1.53.6C28.867,30,31.79,28.29,34.25,26.1Zm2.637-7.675a.671.671,0,0,1,.614.23c.165.186.12.674-.18,1.375a6.459,6.459,0,0,0-1.153-1.321A1.863,1.863,0,0,1,36.886,18.43ZM26.742,27.2a6.4,6.4,0,0,0,1.118,1.238c-.731.216-1.222.2-1.386.015S26.475,27.691,26.742,27.2Zm11.627-4.184a21.079,21.079,0,0,1-3.406,3.8,20.714,20.714,0,0,1-4.313,3,6.476,6.476,0,0,0,1.336.151,6.389,6.389,0,0,0,6.383-6.948Z",
    fill: "#212121"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpaceActive);
export default __webpack_public_path__ + "static/media/space_active.d6dba98c2e8c8b049b73abfee7494c10.svg";
export { ForwardRef as ReactComponent };